import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/',         name: 'home',     component: () => import('../views/Home.vue') },
  { path: '/map',      name: 'map',      component: () => import('../views/Map.vue') },
  { path: '/list',     name: 'list',     component: () => import('../views/List.vue') },
  { path: '/about',     name: 'about',     component: () => import('../views/About.vue') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router